import React from "react";
import { ModalProps } from "components/v2/Modals/types/ModalProps";
import classes from "./Modal.module.scss";
import CloseIcon from "assets/icons/v2/CloseIcon";
import classnames from "classnames";
import RoundedCard from "components/v2/Cards/RoundedCard/RoundedCard";

const Modal: React.FC<ModalProps> = (ModalProps) => {
  return ModalProps.isOpen ? (
    <div
      className={classnames(
        classes["modal-content"],
        ModalProps.additionalClassNames,
      )}
    >
      <span
        className={
          ModalProps.leftClose ? classes.close : classes["right-close"]
        }
        onClick={ModalProps.onClose}
      >
        {ModalProps.roundedClose ? (
          <RoundedCard
            icon={<CloseIcon />}
            customStyles={classes["rounded-close-card"]}
          />
        ) : (
          <CloseIcon />
        )}
      </span>
      {ModalProps.children}
    </div>
  ) : null;
};
export default Modal;
